/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgObjectIs = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M19 2a3 3 0 0 0-2.704 4.301L14.597 8H9.403l-1.7-1.699a3 3 0 1 0-1.418 1.41L8 9.426v5.148L6.286 16.29a3 3 0 1 0 1.418 1.41L9.403 16h2.45v-2H10v-4h4v1.276h2v-1.85l1.714-1.715A3 3 0 1 0 19 2zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM4 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm13.15 2.688V20.02c.92.344 1.804.516 2.652.516.504 0 .9-.084 1.188-.252s.432-.4.432-.696a.618.618 0 0 0-.276-.516c-.184-.144-.54-.304-1.068-.48l-.912-.312c-.744-.256-1.288-.584-1.632-.984-.336-.408-.504-.928-.504-1.56 0-.544.136-1.012.408-1.404.28-.392.672-.692 1.176-.9.504-.216 1.104-.324 1.8-.324.44 0 .872.044 1.296.132.432.08.808.192 1.128.336v1.668a6.932 6.932 0 0 0-1.248-.36 5.815 5.815 0 0 0-1.176-.132c-.992 0-1.488.292-1.488.876 0 .224.092.408.276.552.192.136.548.292 1.068.468l.912.312c.784.272 1.34.604 1.668.996.328.384.492.908.492 1.572 0 .816-.292 1.46-.876 1.932-.576.472-1.392.708-2.448.708a10.22 10.22 0 0 1-2.112-.228 3.463 3.463 0 0 1-.756-.252z" />
        <path d="M13.852 22v-8.724h1.872V22z" />
      </g>
    </g>
  </Icon>
);
export { SvgObjectIs as ObjectIs };
